import { useSearchParams } from 'react-router-dom'
import { SsoHandoff } from '../components/auth/SsoHandoff'
import { API_BASE_URL } from '../lib/api/client'
import { buildLoginUrl } from '../lib/auth/return-to'

/**
 * SSO/enterprise-OIDC entry point, mounted at `/login/sso` (Gate 2 UX spec
 * §2.1 flow map, "Entry: fictiv.com/login…"). F0.2 built the OIDC redirect
 * mechanics; F0.3 added the credential email/password screen
 * (`./LoginPage.tsx`) at `/login` itself and moved this component to
 * `/login/sso` — LoginPage links here as an explicit manual "Sign in with
 * SSO instead" choice, since no domain-lookup endpoint exists yet to detect
 * an SSO-only account automatically (see LoginPage's SCOPE NOTE).
 *
 * This hands off to the BFF's SINGLE GLOBAL OIDC provider (S0.3,
 * `GET /api/auth/login`) — not the per-account enterprise SSO route. F0.4's
 * `<CompanySsoPage>` (`/login/company`) is the entry point for THAT flow
 * (`GET /api/auth/sso/login?domain=...`, S0.5); the two are deliberately
 * separate because they resolve to different BFF routes and different IdP
 * configs, see `<CompanySsoPage>`'s doc comment.
 *
 * The actual handoff presentation (auto-redirect + manual fallback link +
 * focus management) lives in the shared `<SsoHandoff>` component.
 */
export function LoginRedirectPage() {
  const [searchParams] = useSearchParams()
  const requestedReturnTo = searchParams.get('returnTo') ?? undefined
  const loginUrl = buildLoginUrl(API_BASE_URL, requestedReturnTo)

  return <SsoHandoff loginUrl={loginUrl} />
}
